/**
 * L'Atelier 33 — Paneles laterales de la ficha (.pdp-panel): guía de tallas, cuidados, envíos...
 *
 * ⚠ Vive en un ARCHIVO PROPIO y se carga en TODA la tienda desde `layout/theme.liquid`.
 * Antes era un `<script type="module">` dentro de `snippets/size-guide.liquid`, y eso lo dejaba
 * fuera de dos sitios donde sí hace falta (2026-08-18):
 *   1. Las páginas de COLECCIÓN, donde ese snippet no se pinta pero sí se abre el modal de
 *      compra rápida — que trae la guía de tallas dentro.
 *   2. El propio modal: su contenido se inyecta con JavaScript, y un `<script>` insertado así
 *      NO se ejecuta nunca.
 * El resultado era que el enlace "Guía de tallas" del modal no abría nada.
 */
(() => {
    // Script genérico de paneles laterales de la ficha (.pdp-panel).
    // ⚠ Se busca primero DENTRO del modal de compra rápida abierto. El modal clona la ficha, así
    // que puede haber DOS paneles con el mismo id (el de la página y el del modal) y
    // `getElementById` siempre devolvería el primero — el de la página, que está detrás y
    // pertenece a otro producto.
    const open = (id) => {
      const modal = document.querySelector('#quick-add-dialog dialog[open]');
      const dlg = (modal && modal.querySelector('#' + CSS.escape(id))) || document.getElementById(id);
      if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
    };
    document.addEventListener('click', (e) => {
      // Compat: enlace antiguo "Guía de tallas" sin id explícito.
      const legacy = e.target.closest('[data-size-guide-open]');
      if (legacy) {
        e.preventDefault();
        open('pdp-size-guide');
        return;
      }
      const opener = e.target.closest('[data-panel-open]');
      if (opener) {
        e.preventDefault();
        open(opener.getAttribute('data-panel-open'));
        return;
      }
      const closer = e.target.closest('[data-panel-close], [data-size-guide-close]');
      if (closer) {
        const dlg = closer.closest('dialog');
        if (dlg) dlg.close();
        return;
      }
      // Clic en el fondo (fuera del panel) cierra.
      const panel = e.target.closest('dialog.pdp-panel');
      if (panel && e.target === panel) panel.close();
    });
  })();
